import api from '../api/client';

const getAll = async (appId, includeInactive = false) => {
    const res = await api.get('/api/groups/get-all', {
        params: { app_id: appId, include_inactive: includeInactive },
    });
    return res?.data?.data;
};

const getById = async (groupId, appId) => {
    const res = await api.get(`/api/groups/${groupId}`, {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const create = async (payload) => {
    const res = await api.post('/api/groups/create', payload);
    return res?.data;
};

const update = async (payload) => {
    const res = await api.post('/api/groups/update', payload);
    return res?.data;
};

const updateStatus = async (groupId, isActive) => {
    const res = await api.post('/api/groups/update-status', {
        group_id: groupId,
        is_active: isActive,
    });
    return res?.data;
};

const getMembers = async (groupId, appId) => {
    const res = await api.get(`/api/groups/${groupId}/members`, {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const addMember = async (payload) => {
    const res = await api.post('/api/groups/add-member', payload);
    return res?.data;
};

const removeMember = async (groupId, userId) => {
    const res = await api.post('/api/groups/remove-member', {
        group_id: groupId,
        user_id: userId,
    });
    return res?.data;
};

const getUserGroups = async (userId, appId) => {
    const res = await api.get(`/api/groups/user/${userId}`, {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const updateMember = async (payload) => {
    const res = await api.post('/api/groups/update-member', payload);
    return res?.data;
};

const groupsService = {
    getAll,
    getById,
    create,
    update,
    updateStatus,
    getMembers,
    addMember,
    removeMember,
    getUserGroups,
    updateMember,
};

export default groupsService;
